import { useEffect } from 'react';

/**
 * Sets the document <title> and <meta name="description"> for the current route.
 * Used on inner pages (stack, engines, playbook, changelog, signup) that need
 * per-route SEO metadata distinct from the global index.html values.
 */
export function usePageMeta(title: string, description: string): void {
  useEffect(() => {
    const prevTitle = document.title;
    const prevMeta = document.querySelector<HTMLMetaElement>('meta[name="description"]');
    const prevContent = prevMeta?.content ?? '';

    document.title = title;
    if (prevMeta) {
      prevMeta.content = description;
    } else {
      const meta = document.createElement('meta');
      meta.name = 'description';
      meta.content = description;
      document.head.appendChild(meta);
    }

    return () => {
      document.title = prevTitle;
      if (prevMeta) prevMeta.content = prevContent;
    };
  }, [title, description]);
}
